import axios from "axios";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { getApiUrl } from "../utils/baseUrl";
import ReactTooltip from "react-tooltip";

const apiEndPoint = {
  sendDuplicateCompanyProfileToSalesforce: getApiUrl("sendDuplicateCompanyProfileToSalesforce"),
  sendDuplicateContactToSalesforce: getApiUrl("sendDuplicateContactToSalesforce"),
};
const SalesforceDuplicateModal = (props) => {
  const [selectedValue, setSelectedValue] = useState("update");
  const selectDataValue = (data) => {
    setSelectedValue(data);
  };
  const sendDuplicateCompany = (data) => {
    let accountID = {};
    let newData = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i] && data[i].AccountId && !accountID[data[i].AccountId]) {
        newData.push(data[i]);
        accountID[data[i].AccountId] = data[i].AccountId;
      }
    }
    if (selectedValue.toLowerCase() === "update") {
      axios.post(apiEndPoint.sendDuplicateCompanyProfileToSalesforce, { companies: newData }).then((res) => {
        if (res && res.data && res.data.status && res.data.status.toLowerCase() === "success") {
          if (res.data.data && res.data.data.message && typeof res.data.data.message === "string" && res.data.data.message.toLowerCase() === "salesforce_error") {
            if (res.data.data.description && typeof res.data.data.description === "string") {
              toast.error(res.data.data.description);
            } else {
              toast.error(res.data.data.message);
            }
          } else {
            toast.success(res.data.data && res.data.data.message ? res.data.data.message : "success");
          }
        } else {
          toast.error(res.data.data.message);
        }
      });
      props.closeButton();
    } else {
      props.closeButton();
    }
  };
  const sendDuplicateContact = (data) => {
    if (selectedValue.toLowerCase() === "update") {
      axios.post(apiEndPoint.sendDuplicateContactToSalesforce, { contact: data }).then((res) => {
        if (res && res.data && res.data.status && res.data.status.toLowerCase() === "success") {
          if (res.data.data && res.data.data.message && typeof res.data.data.message === "string" && res.data.data.message.toLowerCase() === "salesforce_error") {
            if (res.data.data.description && typeof res.data.data.description === "string") {
              toast.error(res.data.data.description);
            } else {
              toast.error(res.data.data.message);
            }
          } else {
            toast.success(res.data.data && res.data.data.message ? res.data.data.message : "success");
          }
        } else {
          toast.error(res.data.data.message);
        }
      });
      props.closeButton();
    } else {
      props.closeButton();
    }
  };
  return (
    <Modal size="lg" centered show={props.showButton} onHide={props.closeButton} animation={false} className="">
      <Modal.Header closeButton>
        <Modal.Title>Export to Salesforce as an Account</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="d-flex">
          <div className="col-md-5 py-3">
            <div className="mb-3">{/* <img src={UpgradeIcon} alt="..." className="img-fluid"/> */}</div>
            <p>
              <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1675840194/intel/icons/content_copy_fvf7jo.svg" />
              We have found {props.duplicateCount} duplicate(s).
            </p>
            <p>How would you like to handle duplicate(s)?</p>
            <div className="custom-right-radio ml-2" onChange={(event) => selectDataValue(event.target.value)}>
              <div className="form-check">
                <input className="form-check-input" type="radio" name="flexRadioDefault" id="updateExisting" value="Update" defaultChecked />
                <span className="pseudo-checkmark"></span>
                <label className="form-check-label" htmlFor="updateExisting">
                  Update Existing
                </label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="radio" name="flexRadioDefault" id="ignoreDuplicate" value="Ignore" />
                <span className="pseudo-checkmark"></span>
                <label className="form-check-label" htmlFor="ignoreDuplicate">
                  Ignore Duplicate
                </label>
              </div>
            </div>
          </div>
          <div id="salesforce-view-duplicate-table-container" className="col-md-7 px-2 py-3">
            <table className="trademo-table salesforce-view-duplicate-table w-100">
              <thead>
                <tr>
                  <td className="col-2">S.No</td>
                  <td className="col-5 pl-0">Trademo Name</td>
                  <td className="col-5 pl-0">Salesforce Name</td>
                </tr>
              </thead>
              <tbody>
                {!props || !props.type || typeof props.type !== "string" || props.type.toLowerCase() !== "contacts"
                  ? //below block is for add company to salesforce in intel dash, company profile and UI UE grid
                    props.duplicateData.map((item, index) => (
                      <tr key={index}>
                        <td className="col-2">{index + 1}</td>
                        <td className="text-capitalize col-5 pl-0" data-tip={props.fuzzyData && props.fuzzyData[index] && props.fuzzyData[index].Name && props.fuzzyData[index].Name.length > 24 ? props.fuzzyData[index].Name : ""}>
                          {props.fuzzyData && props.fuzzyData[index] && props.fuzzyData[index].Name ? (props.fuzzyData[index].Name.length > 24 ? `${props.fuzzyData[index].Name.slice(0, 24).toLowerCase()}...` : props.fuzzyData[index].Name.toLowerCase()) : "NA"}
                        </td>
                        <td className="text-capitalize col-5 pl-0" data-tip={item.Name && item.Name.length > 24 ? item.Name : ""}>
                          {item.Name ? (item.Name.length > 24 ? `${item.Name.slice(0, 24).toLowerCase()}...` : item.Name.toLowerCase()) : "NA"}
                        </td>
                        <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" />
                      </tr>
                    ))
                  : //below block is for add contacts to salesforce in intel dash
                    props.duplicateData.map((item, index) => (
                      <tr key={index}>
                        <td className="col-2">{index + 1}</td>
                        <td className="text-capitalize col-5 pl-0" data-tip={item.FirstName && item.LastName ? `${item.FirstName} ${item.LastName}` : ""}>
                          {item.FirstName ? item.FirstName : "NA"} {item.FirstName && item.LastName ? item.LastName : ""}
                        </td>
                        <td className="text-capitalize col-5 pl-0" data-tip={item.FirstName && item.LastName ? `${item.FirstName} ${item.LastName}` : ""}>
                          {item.FirstName ? item.FirstName : "NA"} {item.FirstName && item.LastName ? item.LastName : ""}
                        </td>
                        <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" />
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={props.closeButton}>
          Cancel
        </button>
        {props && props.type && props.type !== "" ? (
          props.type.toLowerCase() === "companies" ? (
            <button className="btn btn-primary btn-sm trademo-new-btn" onClick={() => sendDuplicateCompany(props.duplicateData)}>
              Submit
            </button>
          ) : props.type.toLowerCase() === "contacts" ? (
            <button className="btn btn-primary btn-sm trademo-new-btn" onClick={() => sendDuplicateContact(props.duplicateData)}>
              Submit
            </button>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </Modal.Footer>
    </Modal>
  );
};
export default SalesforceDuplicateModal;
